import Vue from 'vue'
import Router from 'vue-router'
import eventTemplateList from '@/components/EventTemplate/EventTemplateList'
import eventBooking from '@/components/BookingType/eventBooking'
import userProfile from '@/components/management/UserProfile'

import eventTemplate from '@/components/management/EventTemplate'
import eventSlotPattern from '@/components/management/eventSlotPattern';

import resourceType from '@/components/management/ResourceType';
import resourceManagement from '@/components/management/resourceManagement';
import layoutConfig from '@/components/management/LayoutConfiguration';

import reportService from '@/components/Report/ReportService';
import roleManagement from '@/components/management/RoleManagement';
import AdminPage from '@/components/management/AdminPage';


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '/eventTemplateList',
      component: eventTemplateList
    },
    {
      path: '/userProfile',
      name: 'userProfile',
      component: userProfile
    },
    {
      path: '/eventTemplate',
      name: 'eventTemplate',
      component: eventTemplate
    },
    {
      path: '/eventSlotPattern',
      name: 'eventSlotPattern',
      component: eventSlotPattern
    },
    {
      path: '/eventbooking',
      name: 'eventTemplateList',
      component: eventTemplateList
    },
    {
      path: '/eventbooking/:id',
      name: 'eventBooking',
      component: eventBooking
    },
    {
      path: '/layoutConfig',
      name: 'layoutConfig',
      component: layoutConfig
    },
    {
      path: '/resourceType',
      name: 'resourceType',
      component: resourceType
    },
    {
      path: '/resourceType/:id',
      name: 'resourceManagement',
      component: resourceManagement
    },
    { 
      path: '/report',
      name: 'reportService',
      component: reportService
    },
    { 
      path: '/role',
      name: 'roleManagement',
      component: roleManagement
    },
    { 
      path: '/adminPage',
      name: 'AdminPage',
      component: AdminPage
    },
    {
      path: '*',
      name: '/eventTemplateList',
      component: eventTemplateList
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js